var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-us",domProps:{"innerHTML":_vm._s(_vm.aboutUsText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }